import React from 'react';
import { useTranslation } from 'react-i18next';

const colorFor = (v) => {
  if (v >= 8) return '#2EE59D';
  if (v >= 5) return '#48CAE4';
  if (v >= 3) return '#FFB020';
  return '#FF6B35';
};

export const ScoreCard = ({ k, value }) => {
  const { t } = useTranslation();
  const v = value ?? 0;
  return (
    <div className="kite-card p-4" data-testid={`score-card-${k}`}>
      <div className="label-eyebrow text-muted-foreground">{t(`scoreLabels.${k}`, { defaultValue: k })}</div>
      <div className="flex items-end gap-1 mt-2">
        <span className="font-data text-3xl font-semibold" style={{ color: colorFor(v) }}>{v}</span>
        <span className="font-data text-sm text-muted-foreground mb-1">/10</span>
      </div>
      <div className="mt-3 h-1.5 rounded-full bg-white/10 overflow-hidden">
        <div className="h-full rounded-full transition-all" style={{ width: `${v * 10}%`, background: colorFor(v) }} />
      </div>
    </div>
  );
};
